import { computed, Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    private runningRequests = signal(0);
    private pauseLoaderSignal = signal(false);

    readonly loading = computed(() => !this.pauseLoaderSignal() && this.runningRequests() > 0);

    show() {
        if (this.pauseLoaderSignal()) return;
        this.runningRequests.update(v => v + 1);
    }

    hide() {
        if (this.pauseLoaderSignal()) return;
        this.runningRequests.update(v => Math.max(0, v - 1));
    }

    set pauseLoader(val: boolean) {
        if (!val) {
            this.runningRequests.set(1);
        }
        this.pauseLoaderSignal.set(val);
    }
}
